import React, { useContext } from 'react';
import UserContext from '../context/UserContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaShoppingBag } from 'react-icons/fa';
import { Redirect } from 'react-router-dom';
const ProductDetails = () => {
	const context = useContext(UserContext);
	const goBack = () => {
		context.setProduct({});
		context.setViewProduct(false);
	};
	const checkProduct = (item) => {
		return context.checkCart(item)
			? context.setCartItem([...context.cartItem, item])
			: toast('Already Added in the cart 🛒🛒!', {
					type: 'warning',
					position: 'top-right',
					autoClose: 2000,
			  });
	};
	if (!context.viewProduct) return <Redirect to="/viewItems" />;
	if (context.cart) return <Redirect to="/CartItems" />;
	return (
		<div className="productDetails__wrapper">
			<ToastContainer />
			<div className="productDetails__backbutton">
				<button
					onClick={() => goBack()}
					className="button__productDetails__backbutton"
				>
					◀Go Back
				</button>
			</div>
			<div className="productDetails__container">
				<div className="productDetails__img">
					<img src={context.product.img} alt={context.product.productName} />
				</div>

				<div className="productDetails__description">
					<div className="productDetails__heading">
						<h4>{context.product.productName}</h4>
					</div>
					<div className="productDetails__price">
						<p>{context.product.productPrice}</p>
					</div>
					<div className="productDetails__overview">
						<p>
							{' '}
							Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
							eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
							enim ad minim veniam, quis nostrud exercitation ullamco laboris
							nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
							reprehenderit in voluptate velit esse cillum dolore eu fugiat
							nulla pariatur. Excepteur sint occaecat cupidatat non proident,
							sunt in culpa qui officia deserunt mollit anim id est laborum.{' '}
						</p>
					</div>
					<div
						className="productDetails__addtoCart"
						onClick={() => checkProduct(context)}
					>
						{context.checkCart(context) ? ' Add to Cart' : 'Added to Cart'}
						<FaShoppingBag />
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProductDetails;
